const BREAKPOINTS = {
    SM: 575.95,
    MD: 767.95,
    LG: 991.95,
    XL: 1199.95,
    XXL: 1399.95,
    XXXL: 1549.95,
}

export default BREAKPOINTS